import React from "react";
import ReactQuill from "react-quill";
import { FormGroup, Label } from "reactstrap";
import PropTypes from "prop-types";
import { Field, getIn } from "formik";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";

const FormEditorFieldInner = (props) => {
  const { label, placeholder, form, field, disabled = false } = props;

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      ["clean"],
    ],
  };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "align",
    "color",
    "background",
  ];

  const { t } = useTranslation();

  const error = getIn(form.errors, field.name) || form.errors[field.name];
  const touched = getIn(form.touched, field.name);
  const value = getIn(form.values, field.name) || "";

  const element = (
    <>
      <ReactQuill
        theme="snow"
        type="text"
        modules={modules}
        formats={formats}
        name={field.name}
        value={value}
        placeholder={placeholder}
        disabled={form.isSubmitting || disabled}
        onBlur={() => form.setFieldTouched(field.name, true)}
        onChange={(value) => {
          form.setFieldValue(field.name, value);
        }}
      />
      {(form.submitCount > 0 || touched) && error && (
        <label style={{ color: "red" }}>{t(error)}</label>
      )}
    </>
  );

  return (
    <div style={{ display: "flex" }}>
      <div style={{ flexGrow: 1 }}>
        <Label>{label}</Label>
        <FormGroup>{element}</FormGroup>
      </div>
    </div>
  );
};

const FormEditorField = (props) => {
  return <Field {...props} component={FormEditorFieldInner} />;
};

FormEditorField.defaultProps = {
  label: "",
  placeholder: "",
  disabled: false,
};

FormEditorField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FormEditorField;
